// src/features/chat/components/his/Collapse.jsx
import React from 'react';
import styles from '../../styles/HisArtifact.module.css';

/**
 * Height-collapse primitive (grid-rows 0fr ↔ 1fr). Motion is disabled under
 * prefers-reduced-motion via the shared module. Closed content is hidden from
 * pointer, keyboard, and assistive tech (visibility + aria-hidden), not just
 * visually collapsed.
 */
export function Collapse({ open, children }) {
  return (
    <div className={styles.collapse} data-open={open ? 'true' : 'false'}>
      <div aria-hidden={open ? undefined : 'true'}>{children}</div>
    </div>
  );
}

export default Collapse;
